import React from 'react'
import { useSelector } from 'react-redux'
import { useFormatMessage } from 'src/providers/intl'
import { FormattedMessage, defineMessages } from 'react-intl'
import classnames from 'classnames'
import history from 'src/history'

// Components
import QuestionSingle from 'src/Components/shared/Questions/QuestionSingleContainer'
import { Text, Button } from 'src/Components'

// Selectors
import {
  selectCustomerFirstName,
  selectCustomerPhotoUri
} from 'src/store/selectors/customerProfile'

// Utils
import { QUESTIONS } from 'src/constants/messages'
import { OVERLAY_HELPERS } from 'src/constants/navigation'

// Styles
import panelStyles from 'src/Components/shared/Panel/Panel.module.scss'
import styles from './EmailUpdatesPanel.module.scss'

const EmailUpdatesPanel = () => {
  const customerFirstName = useSelector(selectCustomerFirstName)
  const avatarUri = useSelector(selectCustomerPhotoUri)
  const intlFormat = useFormatMessage()

  const handleBackToPreferences = () =>
    history.push(OVERLAY_HELPERS.preferences.buildPath())

  return (
    <>
      <div className={classnames(panelStyles.container, styles.container)}>
        <Text size='xl'>
          <FormattedMessage
            id='EmailUpdates.panel.title'
            defaultMessage='Need to update your email?'
          />
        </Text>
        <Text size='s' color='heather'>
          <FormattedMessage
            id='EmailUpdates.panel.subTitle'
            defaultMessage='{customer} is happy to edit your email address for you. Send him a quick note:'
            values={{ customer: customerFirstName }}
          />
        </Text>
        <div className={styles.question}>
          <QuestionSingle
            disableCospo
            questionTopic={intlFormat(QUESTIONS.emailUpdate)}
            placeholder={intlFormat(message.placeholder)}
            avatarUri={avatarUri}
          />
        </div>
      </div>
      <Button onClick={handleBackToPreferences}>
        <FormattedMessage
          id='EmailUpdates.panel.back.button'
          defaultMessage='Back to preferences'
        />
      </Button>
    </>
  )
}

const message = defineMessages({
  placeholder: {
    id: 'EmailUpdates.panel.message.placeholder',
    defaultMessage: 'Can you update my email?'
  }
})

export default EmailUpdatesPanel
